import adminMiddleware from "@/components/privacy/admin/ducks/middleware"
import userMiddleware from "@/components/privacy/ducks/middleware"

export default [userMiddleware, adminMiddleware]
